import { Phone, Clock, Globe, Star } from "lucide-react";
import { BUSINESS } from "@/data";

export const Footer = () => (
  <footer className="bg-[#0A0A0A] text-white" data-testid="site-footer">
    <div className="mx-auto max-w-[1400px] px-4 sm:px-8 py-16">
      <div className="grid grid-cols-1 gap-10 border-b border-white/15 pb-12 lg:grid-cols-3">
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-[#FF4E00]">Call / Text</div>
          <a href={`tel:${BUSINESS.phoneRaw}`} data-testid="footer-phone" className="mt-3 flex items-center gap-2 font-anton text-3xl uppercase transition-colors hover:text-[#FF4E00]">
            <Phone size={22} /> {BUSINESS.phone}
          </a>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-[#FF4E00]">Hours</div>
          <div className="mt-3 flex items-center gap-2 font-anton text-3xl uppercase">
            <Clock size={22} /> 6AM – 6PM
          </div>
          <div className="mt-1 text-sm text-white/50">Open 7 days · Same-day service</div>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-[#FF4E00]">Online</div>
          <div className="mt-3 flex items-center gap-2 font-anton text-2xl uppercase">
            <Globe size={20} /> {BUSINESS.website}
          </div>
          <div className="mt-2 flex items-center gap-1 text-sm text-white/70">
            <Star size={14} className="fill-[#FF4E00] text-[#FF4E00]" /> {BUSINESS.rating} · {BUSINESS.reviewCount} reviews
          </div>
        </div>
      </div>

      <div className="py-10">
        <h2 className="font-anton uppercase leading-[0.82] tracking-tighter text-[16vw] sm:text-[15vw] lg:text-[13vw]">
          Moe's Dump <span className="text-[#FF4E00]">&</span> Junk
        </h2>
      </div>

      <div className="flex flex-col gap-2 border-t border-white/15 pt-6 text-xs uppercase tracking-[0.15em] text-white/40 sm:flex-row sm:justify-between">
        <span>© {new Date().getFullYear()} {BUSINESS.name} · {BUSINESS.county}, FL</span>
        <a href="/login" data-testid="footer-admin-link" className="hover:text-white">Owner Login</a>
      </div>
    </div>
  </footer>
);
